import { css } from '@emotion/core'

import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

export const modalDeviceFormStyle = css(
  {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    padding: 32,
    '.input-container': {
      width: '100%',
      minWidth: 0,
    },
    '.input-label': {
      marginBottom: 16,
      color: '#272727',
      fontSize: 20,
      fontWeight: 'bold',
      letterSpacing: '1px',
      lineHeight: 'normal',
    },
    '.connect-success-text, .connect-error-text': {
      marginTop: -16,
      fontSize: 16,
      lineHeight: 'normal',
    },
    '.connect-success-text': {
      color: '#676767',
    },
    '.connect-error-text': {
      color: 'rgba(255,0,0,0.5)',
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: {
      padding: 40,
      '.input-label': {
        fontSize: 24,
        letterSpacing: '1.2px',
      },
      '.connect-success-text, .connect-error-text': {
        fontSize: 20,
      },
    },
  }),
)

export const modalDeviceInputStyle = css(
  {
    boxSizing: 'border-box',
    width: '100%',
    height: 61,
    padding: '14px 35px',
    borderRadius: 30,
    fontSize: 22,
    fontWeight: 500,
    letterSpacing: '1.1px',
    lineHeight: 'normal',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: {
      height: 63,
      fontSize: 26,
      letterSpacing: '1.3px',
    },
  }),
)
